import { render } from "./SimpleAdmin.vue?vue&type=template&id=f07734bc&scoped=true"
import script from "./SimpleAdmin.vue?vue&type=script&lang=js"
export * from "./SimpleAdmin.vue?vue&type=script&lang=js"

import "./SimpleAdmin.vue?vue&type=style&index=0&id=f07734bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f07734bc"]])

export default __exports__